define('BookingEngine/app-Reviewpay/main',["./settings", "util", "../app-BEBasket/module", "../../app-Loader/main", '../../app/ui/dialog', "jqueryval", "jqueryvalunob", "sumoselect"], function (settings, util, beBasket, loader, dialog) {
    return {
        run: function () {
            var summary = $(settings.container);

            if (summary.length === 0) {
                window.log("Review and Pay will not be available.");
                return;
            }

            function isNullUndefEmpty(variable) {
                return (variable === null || variable === undefined || variable === "");
            }

            window.log("Loading Review and Pay");
            beBasket.updateBasket();

            $(document).ready(function () {
                AdlAddUpdateItem("pageName", "travel|purchase|reviewandpay");
            });

            $("#importantHolidayInformation").on("click", function (e) {
                e.preventDefault();

                var template = $('#advisorynotes').clone();

                var open = function (id) {
                    $('#' + id).find('.modal-content')
                        .append('<div class="ui-dialog-buttonset" ><button type="button" class="closeItinBtn ui-button ui-corner-all ui-widget" data-dismiss="modal">Close</button></div>')
                };

                dialog.show('', template, { onOpen: open, width: window.innerWidth - 110 }, false, ['modal-closable']);
                template.show();
            });

            //Show promocode
            $(".addpromo").click(function () {
                $("#promoentry").show();
            });

            // Promo Code Prompt
            var promoPromptLib = function () {
                var $promoHolder = $(".promoHolder");
                var oldPromoCode = "";
                var shouldPrompt = true;

                var show = function () {
                    if (!isActive() && shouldPrompt) {
                        $promoHolder
                            .addClass("errorHolder js-promoPrompt")
                            .append(
                                '<div class="field-validation-error promptError">' +
                                "Please confirm your promo code to check whether it's available." +
                                "</div>"
                            );
                    }
                }

                var hide = function () {
                    $promoHolder
                        .removeClass("errorHolder js-promoPrompt")
                        .find(".promptError").remove();
                }

                var isActive = function () {
                    return $promoHolder.hasClass("js-promoPrompt");
                }

                var setShouldPrompt = function (should) {
                    shouldPrompt = should;
                }

                var setOldPromoCode = function (oldPromo) {
                    oldPromoCode = oldPromo;
                }

                var getOldPromoCode = function () {
                    return oldPromoCode;
                }

                return {
                    show: show,
                    hide: hide,
                    isActive: isActive,
                    setShouldPrompt: setShouldPrompt,
                    setOldPromoCode: setOldPromoCode,
                    getOldPromoCode: getOldPromoCode
                }
            }

            var promoPrompt = new promoPromptLib();

            if ($("#txtpromo").length > 0) {
                $("#txtpromo")
                    .on("focus", function () {
                        promoPrompt.setOldPromoCode($(this).val().trim());

                        $("#promofail").empty();
                    })
                    .on("blur", function () {

                        var curPromoValue = $(this).val().trim();

                        var isEmpty = isNullUndefEmpty(curPromoValue);

                        // If cur field value is empty, lets remove promo prompt
                        if (isEmpty) {
                            promoPrompt.hide();
                        }
                    });
            }

            //Submit promocode form
            $("#submitpromo").on("click", function (event) {
                event.preventDefault();

                var promocodeValue = $("#txtpromo").val();

                // Don't allow to prompt, and hide any existing prompt
                promoPrompt.setOldPromoCode(promocodeValue.trim());
                promoPrompt.setShouldPrompt(false);
                promoPrompt.hide();

                var isFormValid = $("#promo").valid();

                if (isFormValid) {
                    var request = $.ajax({
                        url: settings.submiturl + "ApplyPromoCode",
                        type: "POST",
                        dataType: "json",
                        data: { promocode: promocodeValue },
                        cache: false
                    });

                    request.done(function (data) {
                        promoPrompt.setShouldPrompt(true); // Allow promo code to prompt again

                        $("#promofail").empty();
                        $("#promosuccess").empty();
                        $("#ltlpromocode").text("None");

                        if (data.errors === null || data.errors.length <= 0) {
                            location.reload();
                        } else {
                            $.each(data.errors, function (i, err) {
                                $("<p>" + err + "</p>").appendTo("#promofail");
                            });
                        }
                    });
                }
            });

            var validateReadDocuments = function () {
                var holInf = $("#ReadHolidayInfo").is(":checked");
                var bkgCond = $("#ReadBkgConditions").is(":checked");

                $("#readDocumentConfirmationError").empty();
                var message = "Please confirm that you have read the ";

                if ($("#ReadIpid").length > 0) {
                    var ipid = $("#ReadIpid").is(":checked");
                    if (!holInf && !bkgCond && !ipid) {
                        message += "Important Holiday Information, Booking Conditions and Insurance Product Information";
                    } else if (!holInf && !ipid) {
                        message += "Important Holiday Information and Insurance Product Information";
                    } else if (!bkgCond && !ipid) {
                        message += "Booking Conditions and Insurance Product Information";
                    } else if (!holInf && !bkgCond) {
                        message += "Important Holiday Information and Booking Conditions";
                    } else if (!holInf) {
                        message += "Important Holiday Information";
                    } else if (!bkgCond) {
                        message += "Booking Conditions";
                    } else if (!ipid) {
                        message += "Insurance Product Information";
                    }

                    if (!holInf || !bkgCond || !ipid) {
                        $("#readDocumentConfirmationError").append(message);
                        $("#readDocumentConfirmationError").show();
                    }

                    return holInf && bkgCond && ipid;
                }

                if (!holInf && !bkgCond) {
                    message += "Important Holiday Information and Booking Conditions";
                } else if (!holInf) {
                    message += "Important Holiday Information";
                } else if (!bkgCond) {
                    message += "Booking Conditions";
                }

                if (!holInf || !bkgCond) {
                    $("#readDocumentConfirmationError").append(message);
                    $("#readDocumentConfirmationError").show();
                }

                return holInf && bkgCond;
            }

            var tradePaymentOptions = $("#tradeAgentPaymentOptions");

            var setUpPayment = function (isDeposit) {
                loader.show();
                var contentWidth = $('.contentSection').width();
                var request = $.ajax({
                    url: settings.submiturl + "SetUpPayment",
                    type: "POST",
                    data: {
                        isDeposit: isDeposit,
                        windowWidth: contentWidth,
                        windowHeight: 800
                    },
                    cache: false
                });

                request.done(function (data) {
                    $("#ConfirmSectionActive").hide();
                    $("#ConfirmSectionSummary").show();

                    if (isDeposit) {
                        $("#depSummary").removeClass("noshow");
                        $("#totalSummary").addClass("noshow");
                        $('#dvsummdep').text($('#depositPayment .paymentPrice').text());

                    } else {
                        $("#depSummary").addClass("noshow");
                        $("#totalSummary").removeClass("noshow");
                    }

                    $("#carddisabled").hide();
                    $("#cardactive").empty();
                    $("#cardactive").html(data).show();

                    // Hide whirly on return
                    loader.hide();

                    //ADL call
                    AdlAddUpdateItem("pageName", "travel|purchase|choosepaymentmethod");

                    function adlChoosePayment() {
                        util.satelliteTrack("virtualPageViewTBJ");

                        //after the tracking call set previous page name to this value
                        //set a timeout to prevent it getting set before it's been read
                        //also add it to local storage so that a page change picks up the correct value
                        setTimeout(function () {
                            var prevpage = localStorage.getItem("previousPageName");

                            if (!isNullUndefEmpty(prevpage)) {
                                AdlAddUpdateItem("previousPageName", prevpage);
                            }

                            localStorage.setItem("previousPageName", "travel|purchase|choosepaymentmethod");
                        }, 999);
                    };

                    clearTimeout(VPVtimer);
                    VPVtimer = setTimeout(adlChoosePayment, 250);

                    //Call SUMO
                    $("select").each(function () {
                        $(this).SumoSelect();
                    });
                });

                request.fail(function () {
                    loader.hide();

                    var errorpage = $("#errorurl").val();
                    window.location.replace(errorpage);
                });
            }

            var setUpTradePaymentOptions = function (isDeposit) {
                tradePaymentOptions
                    .slideDown("fast")
                    .data("isdeposit", isDeposit);

                $("#ConfirmSectionActive").hide();
                $("#ConfirmSectionSummary").show();

                if (isDeposit) {
                    $("#depSummary").removeClass("noshow");
                    $("#totalSummary").addClass("noshow");
                } else {
                    $("#depSummary").addClass("noshow");
                    $("#totalSummary").removeClass("noshow");
                }
            }

            var setUpAgentPayment = function (payLater, shouldRedirect) {
                var request = $.ajax({
                    url: settings.submiturl + "SetUpAgentPayment",
                    type: "POST",
                    data: {
                        "isDeposit": tradePaymentOptions.data("isdeposit"),
                        "payLater": payLater
                    },
                    cache: false
                });

                request.done(function (data) {
                    if (data && shouldRedirect) {
                        window.location.replace(data);
                    }
                });
            }

            $("#skipPayment").on("click", function () {
                AdlAddUpdateItem("paymentOption", "On Request");
                localStorage.setItem("paymentOption", "On Request");

                var readDocs = validateReadDocuments();
                $("#skipPayment:disabled");

                if (!readDocs) {
                    return false;
                } else {
                    $("#skipPayment:enabled");
                }

                var isAgent = $(this).data("isagent");

                if (isAgent) {
                    setUpAgentPayment(false, true);
                }
            });
            var proceedPayment = function (obj) {


                if ($("#txtpromo").length > 0) {
                    var curPromoValue = $("#txtpromo").val().trim();
                    var isPromoEmpty = isNullUndefEmpty(curPromoValue);

                    if (!isPromoEmpty && curPromoValue !== promoPrompt.getOldPromoCode()) {
                        promoPrompt.show();
                    }
                }

                var hasReadImportantDocuments = validateReadDocuments();

                if (hasReadImportantDocuments) {
                    if (promoPrompt.isActive()) {
                        return; // Don't progress if promo prompt is active
                    } else {
                        var isDeposit = $(obj).data("isdeposit");
                        var isAgent = $(obj).data("isagent");

                        if (isAgent) {
                            setUpTradePaymentOptions(isDeposit);
                        } else {
                            setUpPayment(isDeposit);
                        }
                    }
                };
            }
            function showCabinDialog() {
                $("#CabinDialog").dialog({
                    autoOpen: false,
                    modal: true,
                    width: 1000,
                    hide: "fold",
                    show: "fold"

                });
                $("#CabinDialog").dialog("open");
                $("#CabinDialog").on("click", ".choosecabin", function () {
                    var $this = $(this);
                    window.location.replace(window.location.protocol + "//" +
                        window.location.hostname +
                        $this.data("checkouturl"));

                });
            }

            $("#paydeposit, #payinfull, #paydirectdebit").on("click", function () {
                var paymentOption = $(this).text().trim();
                AdlAddUpdateItem("paymentOption", paymentOption);
                localStorage.setItem("paymentOption", paymentOption);
                var $this = $(this);
                proceedPayment($this);
            });

            if (tradePaymentOptions.length > 0) {
                // credit agent continue
                tradePaymentOptions.find("#tradeConfirmCreditBooking").on("click", function () {
                    setUpAgentPayment(false, true);

                });

                // non-credit agent pay later confirm payment agreement
                $("#tradeConfirmPayLaterAgreement").on("click", function () {

                    setUpAgentPayment(true, true);
                });

                // non-credit agent pay later
                tradePaymentOptions.find("#tradePayLater").on("click", function () {
                    var isDeposit = tradePaymentOptions.data("isdeposit");
                    var paymentAgreement = $("#tradeAgentPaymentAgreement");
                    var depositPaymentAmount = paymentAgreement.find(".depositPaymentAmount");
                    var fullPaymentAmount = paymentAgreement.find(".fullPaymentAmount");

                    depositPaymentAmount.hide();
                    fullPaymentAmount.hide();

                    if (isDeposit) {
                        depositPaymentAmount.show();
                    } else {
                        fullPaymentAmount.show();
                    }

                    $("#carddisabled").slideUp("fast");
                    tradePaymentOptions.slideUp("fast");
                    paymentAgreement.slideDown("fast");
                });
            }


            //Amend Payment Amount
            $("#changepayamt").on("click", function () {
                $("#ConfirmSectionSummary").hide();

                displayPaymentOptions();

                $('#ConfirmSectionActive').show();
                //$('#ReadHolidayInfo').prop('checked', true);
                //$('#ReadBkgConditions').prop('checked', true);
                $('#carddisabled').show();
                $('#cardactive').hide();
                $("#tradeAgentPaymentOptions").hide();
                $("#tradeAgentPaymentAgreement").hide();

                paymentSelectionHeight();


            });

            var displayPaymentOptions = function () {
                var options = [$('#fullOption'), $('#ddDDOption'), $('#depositOption')];
                var activeOptions = [];
                for (var i = 0; i < options.length; i++) {
                    if (options[i].length > 0) {
                        activeOptions.push(options[i]);
                    }
                }

                if (activeOptions.length > 1) {
                    var optionClass = "";
                    if (activeOptions.length === 2) {
                        optionClass = "paymentChoice2"
                    } else if (activeOptions.length === 3) {
                        optionClass = "paymentChoice3"
                    }

                    for (var i = 0; i < activeOptions.length; i++) {
                        activeOptions[i].addClass(optionClass);
                        activeOptions[i].removeClass('noshow');
                        activeOptions[i].show();
                    }
                } else if (activeOptions.length === 1) {
                    activeOptions[0].removeClass('noshow');
                    activeOptions[0].show();
                }
            };


            displayPaymentOptions();

            //Call SUMO
            $("select").each(function () {
                $(this).SumoSelect();
            });

            // Create equal height of paymentchoice Selection
            var paymentSelectionHeight = function () {
                if ($(window).width() > 768) {
                    var maxHeight = 0;

                    $(".paymentChoice > div").each(function () {
                        $(this).css("height", "auto");
                        maxHeight = Math.max($(this).outerHeight(), maxHeight);
                    });

                    $(".paymentChoice > div").css({ 'height': maxHeight });
                } else {
                    $('.paymentChoice >div').css({ 'height': 'auto' });
                }
            }

            paymentSelectionHeight();

            $(window).on("resize", paymentSelectionHeight);

            window.loadedModules("BookingEngine/app-Reviewpay");
        }
    }
});
